import { BatchPrintingTemplateResponse } from '@/api/services/common/batch-printing-dashboard/batch-printing-dashboard.dto'
import { StrictNullable } from '@/shared/types/app.types'

export interface DashboardModuleSharedWidgetsPrintLabelsTemplate {
    list: BatchPrintingTemplateResponse[]
    selected: StrictNullable<BatchPrintingTemplateResponse>
}

export interface DashboardModuleSharedWidgetsPrintLabelsState {
    loading: boolean
    templates: DashboardModuleSharedWidgetsPrintLabelsTemplate
}
export const initialDashboardModuleSharedWidgetsPrintLabelsState =
    (): DashboardModuleSharedWidgetsPrintLabelsState => ({
        loading: false,
        templates: {
            list: [],
            selected: null
        }
    })
